if (typeof global.addEventListener === 'function') {
    global.addEventListener('beforeinstallprompt', event => {
        event.preventDefault();
        global.installPromptEvent = event;
    });
}
